export const DASHBOARD = "/";
export const KEY = "/key";
export const SORTING = "/sorting";
export const ANIMATION = "/animation";
export const EDUCATIONAL_PROJECT = "/educational-project";
export const LOGIN = "/login";
export const SIGNUP = "/signup";
